var React = require('react');

function UserAltSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M180.6 107.84a144 144 0 1 1 209.51 161.94zM198.37 320A134.43 134.43 0 0 0 64 454.4v9.6a48 48 0 0 0 48 48h382.2L245.77 320z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.67 480.4l-19.6 25.3a16.06 16.06 0 0 1-22.5 2.8L6.17 53.8a15.93 15.93 0 0 1-2.8-22.4L23 6.2a16.06 16.06 0 0 1 22.5-2.8l588.3 454.7a15.85 15.85 0 0 1 2.87 22.3z","className":"fa-primary","key":2})]);
}

UserAltSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = UserAltSlash;

UserAltSlash.default = UserAltSlash;
